import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    entities: {},
    adding: {},
    editing: {},
    fetching: [],
    addCommentFailedTS: null /** update when add comment failed, only show general error message */,
    addCommentFailedDialog: false
};

const requestComments = (state, action) => {
    return {
        ...state,
        fetching: [...state.fetching, action.resourceId]
    };
};

const receiveComments = (state, action) => {
    return state.entities[action.resourceId]
        ? {
              ...state,
              entities: {
                  ...state.entities,
                  [action.resourceId]: {
                      comments: [...action.comments, ...state.entities[action.resourceId].comments],
                      hasMoreDataToLoad: action.comments.length === 10
                  }
              },
              fetching: state.fetching.filter((item) => item !== action.resourceId),
              lastUpdated: action.receivedAt
          }
        : {
              ...state,
              entities: {
                  ...state.entities,
                  [action.resourceId]: {
                      comments: action.comments,
                      hasMoreDataToLoad: action.comments.length === 10
                  }
              },
              fetching: state.fetching.filter((item) => item !== action.resourceId),
              lastUpdated: action.receivedAt
          };
};

const addComment = (state, action) => {
    return state.entities[action.resourceId]
        ? {
              ...state,
              entities: {
                  ...state.entities,
                  [action.resourceId]: {
                      comments: [...state.entities[action.resourceId].comments, action.comment],
                      hasMoreDataToLoad: state.entities[action.resourceId].hasMoreDataToLoad
                  }
              }
          }
        : {
              ...state,
              entities: {
                  ...state.entities,
                  [action.resourceId]: { comments: [action.comment], hasMoreDataToLoad: false }
              }
          };
};

const addConversationComment = (state, action) => {
    return {
        ...state,
        adding: {
            ...state.adding,
            [action.resourceId]: {
                submitting: true
            }
        },
        addCommentFailedDialog: false
    };
};

const addConversationCommentDone = (state, action) => {
    const newRenderKey = action.error ? state[action.resourceId] : Date.now();
    let newAddCommentFailedTS = state.addCommentFailedTS;
    if (action.error) {
        newAddCommentFailedTS = action.error === 'limit' ? null : Date.now();
    }
    return {
        ...state,
        adding: {
            ...state.adding,
            [action.resourceId]: {
                submitting: false,
                renderKey: newRenderKey
            }
        },
        addCommentFailedTS: newAddCommentFailedTS
    };
};

const editCommentStart = (state, action) => {
    if (!state.editing[action.resourceId]) {
        return {
            ...state,
            editing: {
                ...state.editing,
                [action.resourceId]: {
                    submitting: [action.comment.conversationCommentUuid]
                }
            }
        };
    }
    const newError = [...state.editing[action.resourceId].error].filter(
        (item) => item !== action.comment.conversationCommentUuid
    );
    const newSubmitting = [...state.editing[action.resourceId].submitting, action.comment.conversationCommentUuid];
    return {
        ...state,
        editing: {
            ...state.editing,
            [action.resourceId]: {
                ...state.editing[action.resourceId],
                error: newError,
                submitting: newSubmitting
            }
        }
    };
};

const editCommentDone = (state, action) => {
    let newComments = [];

    if (!state.entities[action.resourceId]) {
        newComments = [action.comment];
    } else {
        newComments = [...state.entities[action.resourceId].comments];
        const replaceIndex = newComments.findIndex((item) => {
            return item.conversationCommentUuid === action.comment.conversationCommentUuid;
        });
        newComments.splice(replaceIndex, 1, action.comment);
    }
    let newError = [];
    let newSubmitting = [];
    if (state.editing[action.resourceId]) {
        newError = [...(state.editing[action.resourceId].error || [])].filter(
            (item) => item !== action.comment.conversationCommentUuid
        );
        newSubmitting = [...(state.editing[action.resourceId].submitting || [])].filter(
            (item) => item !== action.comment.conversationCommentUuid
        );
    }

    return {
        ...state,
        entities: {
            ...state.entities,
            [action.resourceId]: {
                comments: newComments,
                hasMoreDataToLoad: state.entities[action.resourceId].hasMoreDataToLoad
            }
        },
        editing: {
            ...state.editing,
            [action.resourceId]: {
                ...state.editing[action.resourceId],
                error: newError,
                submitting: newSubmitting
            }
        }
    };
};

const editCommentError = (state, action) => {
    if (!state.editing[action.resourceId]) {
        return {
            ...state,
            editing: {
                ...state.editing,
                [action.resourceId]: {
                    error: [action.comment.conversationCommentUuid]
                }
            }
        };
    }
    const newError = [...(state.editing[action.resourceId].error || []), action.comment.conversationCommentUuid];
    const newSubmitting = [...(state.editing[action.resourceId].submitting || [])].filter(
        (item) => item !== action.comment.conversationCommentUuid
    );
    return {
        ...state,
        editing: {
            ...state.editing,
            [action.resourceId]: {
                ...state.editing[action.resourceId],
                error: newError,
                submitting: newSubmitting
            }
        }
    };
};

const removeComment = (state, action) => {
    return {
        ...state,
        entities: {
            ...state.entities,
            [action.resourceId]: {
                comments: state.entities[action.resourceId].comments.filter(
                    (el) => el.conversationCommentUuid !== action.conversationCommentUuid
                ),
                hasMoreDataToLoad: state.entities[action.resourceId].hasMoreDataToLoad
            }
        }
    };
};

const manageCommentLikes = (state, action) => {
    return {
        ...state,
        entities: {
            ...state.entities,
            [action.resourceId]: {
                comments: state.entities[action.resourceId].comments.map((el) =>
                    el.conversationCommentUuid === action.conversationCommentUuid
                        ? {
                              ...el,
                              likedByUser: action.add,
                              numberOfLikes: action.add ? ++el.numberOfLikes : --el.numberOfLikes
                          }
                        : el
                ),
                hasMoreDataToLoad: state.entities[action.resourceId].hasMoreDataToLoad
            }
        }
    };
};

const removeProfilePageCommentsProfileImage = (state, action) => {
    let newEntities = {
        ...state.entities
    };

    let updated = false;

    const resourceIds = Object.keys(newEntities);
    resourceIds.forEach((resourceId) => {
        if (!newEntities[resourceId] || !newEntities[resourceId].comments) {
            return;
        }

        newEntities[resourceId].comments.forEach((comment) => {
            if (comment.authorDisplayName !== action.displayName) {
                return;
            }
            comment.authorImageUrl = null;
            updated = true;
        });
    });

    if (!updated) {
        return state;
    }

    return {
        ...state,
        entities: newEntities
    };
};

const resetToInitialState = () => INITIAL_STATE;

const handlers = {
    [types.REQUEST_COMMENTS]: requestComments,
    [types.RECEIVE_COMMENTS]: receiveComments,
    [types.FAILED_COMMENTS]: receiveComments,
    [types.ADD_COMMENT]: addComment,
    [types.ADD_CONVERSASION_COMMENT]: addConversationComment,
    [types.ADD_CONVERSASION_COMMENT_DONE]: addConversationCommentDone,
    [types.EDIT_COMMENT_START]: editCommentStart,
    [types.EDIT_COMMENT_DONE]: editCommentDone,
    [types.EDIT_COMMENT_ERROR]: editCommentError,
    [types.REMOVE_COMMENT]: removeComment,
    [types.MANAGE_COMMENT_LIKES]: manageCommentLikes,
    [types.REMOVE_PROFILE_PAGE_COMMENTS_PROFILE_IMAGE]: removeProfilePageCommentsProfileImage,
    [types.RESET_COMMENTS]: resetToInitialState
};

export const getComments = (state) => {
    return state.comments.entities;
};

export const getCommentsEditing = (state) => {
    return state.comments.editing;
};

export const getCommentsFetching = (state) => {
    return state.comments.fetching;
};

export const getCommentsAdding = (state) => {
    return state.comments.adding;
};

export const getAddCommentError = (state) => {
    return state.comments.addCommentFailedTS;
};

export const getAddCommentErrorDialog = (state) => {
    return state.comments.addCommentFailedDialog;
};

export default function comments(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
